import React from 'react';

import { Recommendation } from '../../types'

import {
    Card,
    Clickable,
} from '@fabric-ds/react';

import { ribbon } from '@fabric-ds/component-classes';

type AdProps = {
    item: Recommendation;
}

const CmsArticle = (props: AdProps) => {
    const {
        item,
    } = props;

    return (
        <div className="hover:bg-aqua-50 rounded-8 p-10 focus:ring-2">
            <Card className="f-card border-none shadow-aqua-400">
                <div aria-owns={item.itemId}></div>
                <div className="flex flex-col">
                    <div className="aspect-w-2 aspect-h-1">
                        <img
                            alt=""
                            className="w-full h-full object-center object-contain m-auto"
                            src={item.image.url}
                            style={{maxWidth: '65%', maxHeight: '65%'}}
                        />
                    </div>
                    <h4 className="text-gray-700 pt-6 pl-6 pb-32" id={item.itemId}>
                        <Clickable 
                            href={`/${item.itemId}`}
                            className="text-current hover:no-underline focus:no-underline"
                        >
                            {item.heading}
                        </Clickable>
                    </h4>
                    <span
                        className={`${ribbon.base} ${ribbon.sponsored} absolute text-12 top-12 left-12`}
                    >Nyttige artikler</span>
                </div>
            </Card>
        </div>
    );
};

export default CmsArticle;
